export default __webpack_public_path__ + "static/media/Quantico-Italic.d165f772.ttf";